import type {
  APITaskArtifact,
  BranchArtifact,
  BranchArtifactData,
  GitHubArtifactData,
  GitHubResourceArtifact,
} from '../types/api-task'

/**
 * Type guard to check if an artifact is a branch artifact.
 */
function isBranchArtifact(artifact: APITaskArtifact): artifact is BranchArtifact {
  return artifact.type === 'branch' && artifact.provider === 'github'
}

/**
 * Type guard to check if an artifact is a GitHub resource artifact.
 */
function isGitHubResourceArtifact(artifact: APITaskArtifact): artifact is GitHubResourceArtifact {
  return artifact.type === 'github_resource' && artifact.provider === 'github'
}

export const getBranchArtifactData = (artifacts?: APITaskArtifact[]): BranchArtifactData | undefined => {
  const branchArtifact = artifacts?.find(isBranchArtifact)
  return branchArtifact?.data
}

/**
 * Checks if the base_ref and head_ref are the same.
 */
export function baseRefMatchesHeadRef(data?: BranchArtifactData): boolean {
  return data?.base_ref !== undefined && data.base_ref === data.head_ref
}

export const getGitHubArtifactData = (artifacts?: APITaskArtifact[]): GitHubArtifactData | undefined => {
  const ghArtifact = artifacts?.find(isGitHubResourceArtifact)
  return ghArtifact?.data
}
